module.exports = __webpack_public_path__ + "static/media/swiftmed_logo.d5e6dfd8.png";